import { StarIcon } from "@heroicons/react/24/solid";
import React, { FC } from "react";
import Avatar from "shared/Avatar/Avatar";
import dayjs from "dayjs";

interface Review {
  id: number;
  comment: string;
  rating: number | undefined;
  user: {
    image: string | null;
    name: string;
  };
  average: number;
  created_at: string;
}

interface CommentListingProps {
  className?: string;
  data: Review;
}

const CommentListing: FC<CommentListingProps> = ({
  className = "",
  data,
}) => {
  const formattedDate = dayjs(data.created_at).format("DD MMMM YYYY");
  return (
    <div className="w-full max-w-screen-lg mx-auto">
      <div
        className={`nc-CommentListing flex space-x-3 sm:space-x-4 py-2 ${className}`}
        data-nc-id="CommentListing"
      >
        <div className="pt-0.5">
          <Avatar
            sizeClass="h-10 w-10 text-base"
            radius="rounded-full"
            userName={data?.user?.name}
            imgUrl={data?.user?.image || ""}
            showInitials
          />
        </div>
        <div className="flex-grow min-w-0">
          <div className="flex flex-wrap items-start justify-between gap-x-3 gap-y-1">
            <div className="flex flex-col">
              <div className="text-sm font-semibold text-neutral-900 dark:text-neutral-100">
                <span>{data?.user?.name}</span>
              </div>
              <div
                className="flex text-yellow-500 mt-2 sm:mt-3"
                role="img"
                aria-label={`${data?.average || 0} out of 5 stars`}
              >
                {[...Array(5)].map((_, index) => (
                  <StarIcon
                    key={index}
                    className={`w-4 h-4 ${index < data?.average
                      ? "text-yellow-500"
                      : "text-gray-300 dark:text-neutral-600"
                      }`}
                  />
                ))}
              </div>
            </div>
            <span className="text-xs sm:text-sm text-neutral-500 dark:text-neutral-400">
              Posted on - {formattedDate}
            </span>
          </div>
          <span className="block mt-3 text-neutral-6000 dark:text-neutral-300 break-words">
            {data?.comment}
          </span>
        </div>
        <hr className="border-t border-gray-300 dark:border-gray-600" />
      </div>
    </div>
  );
};

export default CommentListing;